import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si nunca cobré por decorar?',
  a: 'Sí. El sistema arranca desde "lo hago gratis para mis amigas" y te lleva paso a paso hasta poder cobrar tu primer evento con un presupuesto claro.'
}, {
  q: '¿Necesito saber diseño gráfico o usar programas complicados?',
  a: 'No. Todo el material ya está armado — imágenes, presupuestos, contratos. Los prompts de IA para renders los usás directo en apps gratuitas como Gemini o Meta AI.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato después del pago. Digital — celular, tablet o computadora.'
}, {
  q: '¿Qué diferencia hay entre los dos planes?',
  a: 'El Plan Base tiene los 6 tomos y 4 bonos — ideal para arrancar a decorar y cobrar. El Plan PRO/Élite agrega los prompts de IA para renders, contratos y señas, y la masterclass para profesionalizarte.'
}, {
  q: '¿Sirve para cualquier tipo de evento o solo cumpleaños infantiles?',
  a: 'Cubre 6 categorías: cumpleaños infantiles, mesversarios/baby showers, XV, casamientos íntimos, eventos corporativos chicos y fiestas de adultos.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="py-16 px-5 bg-[#FFF9F1]" data-id="element-67">
      <div className="max-w-md mx-auto" data-id="element-68">
        <h2 className="text-2xl font-bold text-wine text-center mb-8" data-id="element-69">
          Lo que más nos preguntan
        </h2>

        <div className="flex flex-col gap-3" data-id="element-70">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white border border-cream rounded-xl overflow-hidden shadow-sm" data-id="element-71">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full p-4 flex items-center justify-between text-left" data-id="element-72">
                <span className="font-bold text-[15px] text-wine pr-4" data-id="element-73">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-wine/50 shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-74" />
              </button>

              <AnimatePresence initial={false} data-id="element-75">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-76">
                    <div className="p-4 pt-0 text-[15px] text-dark/80 leading-relaxed border-t border-cream mt-2" data-id="element-77">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}